module.exports = __webpack_public_path__ + "img/accounts_active.5cbb9904.svg";